const ContactUs = () => {
  return (
    <div className="container mx-auto px-4 py-10 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Contact Us</h1>

      <p className="mb-2">Email: luxorclothingshelp@gmail.com</p>
      <p className="mb-2">Phone: +91-9216650530</p>
      <p>Address: ganaganagar, rajasthan, india</p>
    </div>
  );
};

export default ContactUs;